export const Progress = ({ ratio }) => {
  const p = Math.round(ratio * 100) + "%"
  return (
    <div className="my-4 container-sm container-mini progress-holder">
      <div className="progress-bar" style={{ width: p }}>
        <span>{p}</span>
      </div>
    </div>
  )
}
